import { Injectable } from '@angular/core';
import { TableData } from '../model/model';

@Injectable({
  providedIn: 'root'
})
export class FilterService {
  private filterState: { [key: string]: TableData[] } = {};

  setFilter(column: string, values: TableData[]) {
    this.filterState[column] = values;
  }

  getFilter(column: string): TableData[] {
    return this.filterState[column] || [];
  }

  clearFilter(column: string): void {
    delete this.filterState[column];
  }

  clearAllFilter(){
    this.filterState = {};
  }
}
